import axios from 'axios'

export default {
  getEvent (token) {
    return axios
      .get('event/' + token)
      .then(resp => {
        return resp.data
      })
  },
  getEventCategories (token) {
    return axios
      .get('event/' + token + '/categories')
      .then(resp => {
        return resp.data
      })
  },
    getEventParticipants (token, password) {
        return axios
            .get('event/participants/' + token + '/' + password)
            .then(resp => {
                return resp.data
            })
    }
}
